var data = {
  title: 'kidstopia',
}

export default data



// WEBPACK FOOTER //
// ./src/utils/app_data.js